import React, { useState, useEffect } from 'react'
import { Badge, Input, InputAdornment, Typography } from '@material-ui/core';
import {
    Menu as MenuIcon,
    Search as SearchIcon
} from '@material-ui/icons';
import BreadcrumComponent from "../../components/BreadCrums/breadcrums";
import UserImage from '../../assets/img/profileImage.png';
import Chat from './components/chat/Chat';
import { Scrollbars } from 'rc-scrollbars';
import { formatDateTime, communicationFormatedDate } from '../../components/Common/Extensions';

import useStyles from "./styles";
import { PostDataAPI } from '../../../src/Services/PostDataAPI';
import { GetUserInfo } from '../../Services/GetUserInfo';
import profilePlaceholder from '../../assets/img/profilePlaceholder.jpg';
import ClearIcon from '@material-ui/icons/Clear';

function Communication() {
    const classes = useStyles();
    const [customerID] = useState(JSON.parse(GetUserInfo()).user.userId);
    const [customerList, setCustomerList] = useState([])
    const [isUpdate, setIsUpdate] = useState(false);
    const [showChat, setShowChat] = useState(true);
    let isFirstTime = true;
    const [showToggle, setShowToggle] = useState(window.isMobileView ? false : true);

    const [showChatMobile, setShowChatMobile] = useState(false);

    const [loading, setLoading] = useState(false);

    const Togglecollapse = () => {
        if (showToggle == true) {
            setShowToggle(false)
        } else {
            setShowToggle(true)
        }
    }

    const openChatScreen  = () => {
        setShowChatMobile(true)
    }
    const closeChatScreen = () => {
        setShowChatMobile(false)
    }


    const handleUpdate = () => {
        setIsUpdate(!isUpdate);
    }
    const [search, setSearchValue] = useState('');

    const onSearchChange = (e) => {
        const { name, value } = e.target;
        sessionStorage.setItem('customerSearchValue', value);
        setSearchValue(prevState => ({
            ...prevState,
            [name]: value
        }))
        loadCustomers();
    }

    const handleClearInput = (name) => {
        sessionStorage.setItem('customerSearchValue', '');
        setSearchValue(prevState => ({
            ...prevState,
            [name]: ''
        }))
        loadCustomers();
    };

    const [selectedCustomer, setSelectedCustomer] = useState({});

    function loadCustomers() {
        let reqData = {
            userName: sessionStorage.getItem('customerSearchValue') ? sessionStorage.getItem('customerSearchValue') : '',
            customerID: customerID?.toString()
        }
        
        setLoading(true);
        PostDataAPI("customer/LoadChatSupportUsers", reqData).then((result) => {
            console.log(result.data)
            if (result.success && result.data.length > 0) {
                setCustomerList(
                    result.data.map((item, i) => {
                        item.fullName = item.firstName + ' ' + item.lastName
                        return { ...item }
                    }));
                if (isFirstTime) {
                    isFirstTime = false;
                    setSelectedCustomer(result.data[0]);
                    sessionStorage.removeItem("supportChatObj");
                    sessionStorage.setItem('supportChatObj', JSON.stringify(result.data[0]));
                }
                var ui = GetUserInfo();
                if (ui)
                    startCounter();
            }
            else {
                setCustomerList([]);
            }
            handleUpdate();

        })
    }

    function reloadCustomerList() {
        loadCustomers(search);
    }

    function handleCustomerSelection(index) {

        setShowChat(false);
        setSelectedCustomer(index);
        sessionStorage.removeItem("supportChatObj");
        sessionStorage.setItem('supportChatObj', JSON.stringify(index));

        setTimeout(function () {
            setShowChat(true);
            openChatScreen()
            handleUpdate();
        }, 100);
    }

    const startCounter = () => { setTimeout(function () { loadCustomers(search); }, 9000); }
    useEffect(() => {
        loadCustomers('')
        return () => {
            sessionStorage.removeItem("supportChatObj");
            sessionStorage.removeItem('customerSearchValue')
        }
    }, []);

    return (
        <>
            <div className={classes.appBarSpacer} />
            {window.isMobileView ? '' :
                <div className={classes.header}>
                    <BreadcrumComponent parentLink="Communication" >Communication</BreadcrumComponent>
                    {/* <div className={classes.rightHeader}>
              <h2> Friday , January 13, 2023 | 11:38 AM <span className="greyText"> Last Login: Thursday January 12, 2023 | 05:30 PM</span></h2>
          </div> */}
                </div>}

            <div className={classes.container}>

                <div className={`${showToggle ? classes.leftContainer : classes.leftContainerToggle} ${window.isMobileView && showChatMobile ? classes.leftContainerMobileZero : window.isMobileView && !showChatMobile ? classes.leftContainerMobilefull : ''}`}>

                    <div className={classes.leftHeader}>
                        <MenuIcon color='#707991' onClick={Togglecollapse} />
                        <Input
                            id='searchValue'
                            name='searchValue'
                            value={search.searchValue}
                            type='search'
                            disabled={false}
                            placeholder='Name/Email/Account'
                            // className={"custom-input"}
                            autoComplete="off"
                            endAdornment={search.searchValue ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('searchValue') }} /> : ''}
                            startAdornment={
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            }
                            onChange={onSearchChange}
                            style={{fontSize:'14px'}}
                        />

                    </div>
                    <div className={classes.userListContainer}>
                        <Scrollbars autoHeight autoHeightMin={window.isLaptopView ? window.isMobileView ? '85vh' : 500: 670} autoHeightMax={window.isLaptopView ? 500: 650}>
                            <ul className={classes.userList}>
                                {
                                    customerList.map((support, index) => {
                                        return <li className={support.userId === selectedCustomer.userId ? 'active' : ''} onClick={() => handleCustomerSelection(support)}>
                                            <img src={support.userPhotoPath ? '.' + support.userPhotoPath : profilePlaceholder} alt="user" />
                                            {/* {showToggle  ? */}
                                            <div className={'TextHidden'}>
                                                <span >
                                                    <Typography className='userName'>{support.firstName + ' ' + support.lastName}</Typography>
                                                    <Typography className='messageTime'>{support.messageDateTime == "01/01/1900 00:00:00"?"":communicationFormatedDate(support.messageDateTime)}</Typography>
                                                </span>
                                                {support.chatText ?
                                                    <span >
                                                        <Typography className='messageText'>{support.chatText} </Typography>
                                                    </span> : ''}
                                            </div>
                                            {/* : ''} */}

                                            {support.unreadCount > 0 && <Badge badgeContent={support.unreadCount} color="#0686D8" />}
                                        </li>
                                    })
                                }
                            </ul>
                        </Scrollbars >
                    </div>
                </div>
                <div className={`${classes.rightContainer} ${window.isMobileView && showChatMobile ? classes.rightContainerMobileFull : window.isMobileView && !showChatMobile ?  classes.rightContainerMobileZero: '' }`}>

                    {/*<div className={classes.backBtn}> Back</div>*/}
                    <Chat scrollHeight={ window.isLaptopView ? window.isMobileView ? "80vh" : "67vh" : "70vh"} showUser={true} userData={selectedCustomer} isUpdate={isUpdate} reloadCustomer={reloadCustomerList} closeChatScreen={closeChatScreen} />

                </div>
            </div>
        </>
    )
}

export default Communication